import React from "react";
import {Accordion, Button, Card, Col, Container, Row} from "react-bootstrap";

import {IndicatorConfigView} from '../IndicatorConfigView';
import {IndicatorPerformanceView} from './IndicatorPerformanceView';

import {StockCharts} from '../StockCharts';

import {DISPLAY_CHARTS} from '../constants';

class IndicatorPerfChartPane extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            selectedPosition: null
        }

        this.getSelectedPositionUpdated = this.getSelectedPositionUpdated.bind(this);
    }

    getSelectedPositionUpdated(position){
        console.log("Looking:" + position);
        for(let i = 0; i < this.props.indicatorPerformanceResults.length; i++){
            let stats = this.props.indicatorPerformanceResults[i];
            let theDay = new Date(stats.positionStartTime);
            if(theDay.getTime() === position){
                console.log("found it" + theDay.getTime());
                this.setState({"selectedPosition" : stats});
                break;
            }
        }
    }

    getView() {
        let view = <div>Ready to load charts!</div>

        if(this.props.summaryData.config === null || this.props.summaryData.config === undefined){
            view = <div>Config data Not found for selected day</div>
        } else if (this.props.display){
            view =
                <Container>
                    <Row>
                        <Col>
                            <Accordion key={'tab.config'} defaultActiveKey={'nno'}>
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey={'tab.config'}>
                                            Config: {this.props.summaryData.config.name}
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey={'tab.config'}>
                                        <Card.Body>
                                            <div>Indicator Config</div>
                                            <IndicatorConfigView config={this.props.summaryData.config} />
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <StockCharts chartData={this.props.data} config={this.props.summaryData.config} symbolOptions={DISPLAY_CHARTS} selectedPositionChangeHandler={this.getSelectedPositionUpdated} isFullConfig={false}>
                                <IndicatorPerformanceView  indicatorPerformanceStats={this.props.data} selectedPosition={this.state.selectedPosition} />
                            </StockCharts>
                        </Col>
                    </Row>
                </Container>
        }
        return view;
    }
    render(){return this.getView()}
}
export {IndicatorPerfChartPane}
